import  {useState} from 'react';   
import { Link } from 'react-router-dom'; 
import { useDispatch, useSelector } from 'react-redux';
import paths from '../../routes/paths'; 
import Van from "../../assets/images/tracking.jpg";
import Loader from "../../assets/images/spinner.gif";
import SmallLogo from "../../assets/images/favicon.png";
import Moment from 'react-moment';
import {ThunkDispatch} from "@reduxjs/toolkit";
import {fetchTrackingDetails } from '../../redux/slices/CommonSlice';
import MetaTags from '../Common/MetaTags';

const  TrackOrder = () => {   
  const [trackingNumber, setTrackingNumber] = useState('');
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {formErrors,trackingDetails,loading} = useSelector((state:any) => state.common);
  const [errors, setErrors] = useState("");

    const submitTrackingNumber = () => {
      if(trackingNumber === ''){
        setErrors("Please enter Tracking Number.");
      }
      else{
        dispatch(fetchTrackingDetails({trackingNumber})); 
        setErrors("");
      }
    };
    
      
    return (
      <>   
        <MetaTags
          title="Track Your Order | Anuugha Collections"
          description="Easily track your order status with Anuugha Collections. Enter your details to get real-time updates on your purchase."
          url="https://www.anuughacollections.com/tracking"
          image={process.env.REACT_APP_SERVER_URL + Van}
        />
        <div className="page-content bg-light">

          <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
            <div className="container">
              <div className="dz-bnr-inr-entry">
                <h1 className="text-center">Track Order</h1>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={paths.store} className="menu-title">Home</Link></li>
                    <li className="breadcrumb-item">Search AWB Number</li>
                  </ul>
                </nav>
              </div>
            </div>	
          </div>

          <section className="content-inner">
            <div className="theme-page-section _pv-60 _ph-60 about_one free-shipping shipping-policy p-t-40">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="theme-hero-text theme-hero-text-center m-b-10">
                                <div className="theme-hero-text-header">
                                <div className="container">
                                      <div className="row align-items-center">
                                          <div className="col-lg-5 col-md-6 col-12 mb-4 mb-md-0">
                                              <img src={Van} alt="All over India" className="img-fluid"/>
                                          </div>
                                          <div className="col-lg-7 col-md-6 col-12">
                                              <div className="text-center p-t-30 p-t-md-60">
                                                  <h2 className="mb-4">Track Your Order</h2>
                                                  <p className="text-center mb-4">You can track your order by using tracking number.</p> 
                                                    <form className="tracking-form">
                                                      <input 
                                                        name="tracking_number" 
                                                        type="text" 
                                                        value={trackingNumber} 
                                                        onChange={(e) => setTrackingNumber(e.target.value)} 
                                                        className="form-control mb-3" 
                                                        aria-label="Text input with dropdown button" 
                                                        placeholder="Enter Tracking Number"
                                                      />
                                                      {errors !== '' && <p className='m-b-0 errorMsg text-md-start'>{errors}</p>}
                                                      {errors === '' && formErrors["Error"] && (
                                                        <p className='m-b-0 errorMsg text-md-start'>{formErrors['Error']}</p>
                                                      )}
                                                      { !loading && 
                                                        <button 
                                                          type='button' 
                                                          onClick={() => submitTrackingNumber()} 
                                                          className='btn btn-secondary mt-3 pointer w-100 w-md-auto'
                                                        >
                                                          Submit
                                                        </button>
                                                      }
                                                    </form> 
                                                    { loading && <img src={Loader} className='loadingImg mt-3' alt="Loader"/>}
                                                </div>   
                                          </div>
                                      </div> 
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  {trackingDetails.length !== 0 && 
                    <div className="row order-tracking mt-5">
                        <div className="col-lg-6 col-12 mb-4 mb-lg-0">
                          <div id="tracking" className="p-4 bg-white rounded shadow-sm">
                              <div className="text-center tracking-status-intransit mb-4">
                                <p className="text-tight h5 mb-0">Delivery Details</p>
                              </div>
                              <div className="tracking-list">
                                  <div className="form-group text-center p-t-20">
                                      <div className="mb-3"><span className="bold">AWB No:</span> {trackingDetails['AWB']}</div>
                                      <div className="mb-3"><span className="bold">Pick up Date:</span> <Moment format="DD MMM YYYY, hh:mm A">{trackingDetails['PickUpDate']}</Moment></div>
                                      <div className="mb-3"><span className="bold">Promised Delivery Date:</span> { trackingDetails['PromisedDeliveryDate'] ? <Moment format="DD MMM YYYY, hh:mm A">{trackingDetails['PromisedDeliveryDate']}</Moment> : 'NA'} </div>
                                      <div className="mb-3"><span className="bold">Destination:</span> {trackingDetails['Destination']}({trackingDetails['Consignee']['PinCode']})</div>
                                      <div className="mb-3"><span className="bold">{trackingDetails['Consignee']['State']}({trackingDetails['Consignee']['Country']})</span></div>
                                  </div>
                              </div>
                          </div>
                        </div> 
                        <div className="col-lg-6 col-12"> 
                          <div id="tracking" className="p-4 bg-white rounded shadow-sm">
                              <div className="text-center tracking-status-intransit mb-4">
                                  <p className="text-tight h5 mb-0">Order Tracker</p>
                              </div>
                              <div className="tracking-list scans">
                                {trackingDetails['Scans'].map((scan, index) => 
                                    <div key={index} className="order-tracking-item mb-4">
                                        <div className={"tracking-icon status-intransit status-"+scan['ScanDetail']['Scan'].replace(/\s/g, '')}>
                                          <img src={SmallLogo} alt="logo" className="img-fluid" /> 
                                        </div>
                                        <div className="tracking-date">
                                        { scan['ScanDetail']['ScanDateTime'] && <Moment format="DD MMM YYYY">{scan['ScanDetail']['ScanDateTime']}</Moment>}
                                        <span className="ms-2">{ scan['ScanDetail']['ScanDateTime'] && <Moment format="hh:mm A">{scan['ScanDetail']['ScanDateTime']}</Moment>}</span>
                                        </div>
                                        <div className="tracking-content">
                                          {scan['ScanDetail']['Instructions']} ({scan['ScanDetail']['Scan']})
                                          <span className="d-block mt-1">{scan['ScanDetail']['ScannedLocation']}</span>
                                        </div>
                                    </div>
                                )}
                              </div>
                            </div>   
                        </div>   
                    </div>
                  }
                </div>
            </div>
          </section>

        <section className="content-inner bg0 p-b-15 app-content category-content p-t-20">
              <div className="container">
                  <div className="p-b-10 header">
                        <h1 className="text-center h2">Track Your Order with Ease: Anuugha Collections Transparent and Efficient Order Tracking System</h1>
                  </div>
                  <div className="content">
                      <p className="text-center">Welcome to the Anuugha Collections' Order Tracking page, where we prioritize transparency, efficiency, and a seamless shopping experience for our valued customers. Tracking your order is now as simple as a few clicks, ensuring you stay informed and confident throughout the delivery process.</p>
                      
                      <h2 className="text-center mt-4">Experience the Ease of Order Tracking with Anuugha Collections:</h2>
                      <p className="text-center">At Anuugha Collections, we value your time and trust. Our "Track Your Order" page is designed to provide you with a straightforward and enjoyable tracking experience. Follow your package's journey and eagerly await the moment you can drape yourself in the elegance of your chosen saree.</p>
                      <p className="text-center">Thank you for choosing Anuugha Collections. We look forward to delivering not just products but also a delightful shopping experience to your doorstep. Happy tracking!</p>
                  </div>
              </div>
          </section>
    
        </div> 
      </>
    );
}

export default TrackOrder;

 
